import {
  Button,
  Card,
  Input,
  success,
  SwitchInput,
  UploadImageCard,
  useCustomForm,
  useEffect,
} from "@";
import { saveBanner } from "../utils/api";
import { fillForm } from "../utils/helpers";
import { defaultValues, schema } from "../utils/validation";

const Banner = ({ data, title }) => {
  // Use form
  const {
    watch,
    reset,
    errors,
    setValue,
    register,
    getValues,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
  } = useCustomForm(defaultValues, schema);

  // Upload image for create
  const uploadImage = (file) => {
    setValue("Image", file);
  };

  // Function to fetch data and reset form values
  function fetchData(items) {
    let values = fillForm(items);
    reset(values);
  }

  // Save data
  const submit = async () => {
    try {
      const { data: res } = await saveBanner(getValues());
      success("تم الحفظ بنجاح");
      fetchData(res);
    } catch (error) {}
  };

  // Fetch data on page load
  useEffect(() => {
    fetchData(data);
  }, [data]);

  return (
    <>
      <form onSubmit={handleSubmit(submit)}>
        <Card className="h-full">
          <div className="mb-5 flex items-center justify-between">
            {/* Checkbox for active status */}
            <SwitchInput
              label={title}
              checked={watch("IsActive")}
              change={(value) => setValue("IsActive", value)}
              isBordered={true}
            />
            {/* Submit button */}
            <Button
              className="w-fit py-2.5"
              isLoading={isSubmitting}
              type="submit"
              title="حفظ البيانات"
            />
          </div>

          {/* Input fields for title, subtitle, and URL */}
          <Input
            style="mb-5"
            label="العنوان"
            error={errors.Title}
            input={register("Title")}
          />
          <Input
            style="mb-5"
            label="النص"
            error={errors.Subtitle}
            input={register("Subtitle")}
          />
          <Input
            type="url"
            style="mb-7"
            label="الرابط"
            error={errors.Url}
            input={register("Url")}
          />

          {/* Upload image card */}
          <UploadImageCard
            show={true}
            title="صورة البنر"
            upload={uploadImage}
            success={isSubmitSuccessful}
            error={errors.Image?.message}
            src={getValues("ImageFullUrl")}
            star={!getValues("ImageFullUrl")}
          />
        </Card>
      </form>
    </>
  );
};

export default Banner;
